import React from 'react';

const EmailSocial = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 0C10.7485 0 0 10.7485 0 24C0 37.2515 10.7485 48 24 48C37.2515 48 48 37.2515 48 24C48 10.7485 37.2583 0 24 0ZM36.9719 14.7315L24 25.5959L11.0281 14.7315H36.9719ZM38.3495 34.1415H9.65047V16.1091L23.3794 27.6078C23.3794 27.6078 23.393 27.6078 23.393 27.6147C23.4749 27.676 23.5567 27.7238 23.6522 27.7647C23.6726 27.7715 23.6931 27.7783 23.7136 27.7852C23.809 27.8124 23.9045 27.8329 24 27.8329C24.0955 27.8329 24.191 27.8124 24.2864 27.7852C24.3069 27.7852 24.3274 27.7715 24.3478 27.7647C24.4365 27.7306 24.5252 27.6829 24.607 27.6147C24.607 27.6147 24.6206 27.6147 24.6206 27.6078L38.3495 16.1091V34.1415Z" fill="#EEEEEE"/>
    </svg>
);

export default EmailSocial;
